import { render, staticRenderFns } from "./PrestamoMaterialEdit.vue?vue&type=template&id=56ba9f58&scoped=true&"
import script from "./PrestamoMaterialEdit.vue?vue&type=script&lang=ts&"
export * from "./PrestamoMaterialEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ba9f58",
  null
  
)

export default component.exports